import { render, staticRenderFns } from "./config07-menSuo.vue?vue&type=template&id=8d542702&"
import script from "./config07-menSuo.vue?vue&type=script&lang=js&"
export * from "./config07-menSuo.vue?vue&type=script&lang=js&"
import style0 from "./config07-menSuo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports